/**
 * @generated SignedSource<<4111f618f0245f7b68423cc1fb8ce82e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksUseAcquisitionPopupQuery$data = {
  readonly pptoConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
  readonly settings: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "hooksUseAcquisitionPopupQuery";
};
export type hooksUseAcquisitionPopupQuery$key = {
  readonly " $data"?: hooksUseAcquisitionPopupQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksUseAcquisitionPopupQuery">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "json",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksUseAcquisitionPopupQuery",
  "selections": [
    {
      "alias": "pptoConfig",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "scmp_pwa_ppto"
          }
        }
      ],
      "concreteType": "AppConfig",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_ppto\"})"
    },
    {
      "alias": "settings",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "scmp_pwa_settings"
          }
        }
      ],
      "concreteType": "AppConfig",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_settings\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "3317539a3689a9bba9a7319d54f6cc94";

export default node;
